import { render, staticRenderFns } from "./StakeholdersEditor.vue?vue&type=template&id=423e907a&scoped=true&"
import script from "./StakeholdersEditor.vue?vue&type=script&lang=ts&"
export * from "./StakeholdersEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423e907a",
  null
  
)

export default component.exports